var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[_c('SiteMasthead',{scopedSlots:_vm._u([{key:"cta",fn:function(){return [_c('ContentRow',[_c('ContentContainer',[_c('ListingCardCycler',{attrs:{"listings":_vm.salesListings}})],1)],1)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }